<template>
    <div :class="{'has-error':showError}" class="form-group form-material floating inp-error-marker my-custom-input">
        <input :type="type"
               class="form-control"
               :min="min"
               :pattern="pattern"
               :class="{ error: showError, filled: hasValue, disabled: disabled}"
               autocomplete="off"
               :disabled="disabled"
               :readonly="readonly"
               :placeholder="placeholder"
               :value="value"
               :name="label"
               @input="$emit('input', $event.target.value)"
               style="position: relative;"
               @keyup.enter="$emit('enterClicked', $event)"
               @focus="$emit('focus')"
               @blur="$emit('blur')"
               @keydown="$emit('keydown', $event)"
               @keypress="$emit('keypress', $event)"
               @keyup="$emit('keyup', $event.target.value)" />
        <label class="floating-label">{{label}}</label>
        <span class="icon-input-error"></span>
        <label v-if="required" class="requred-input-indicator">*</label>
        <label v-if="showError" class="text-error">{{ errorMessage }}</label>
    </div>
</template>

<script>

    export default {
        name: "input-text",
        props: {
            type: String,
            label: String,
            required: Boolean,
            disabled: Boolean,
            readonly: Boolean,
            placeholder: String,
            value: {
                default: null
            },
            min: {
                default: 0
            },
            pattern: String,
            showError: Boolean,
            errorMessage: String
        },
        computed: {
            hasValue: function () {
                return this.value != null && this.value != "";
            }
        }
    };
</script>

<style scoped>
    .form-group.form-material .filled {
        background-color: white;
    }

    .form-control.filled.disabled {
        background-color: #8080801c;
        user-select: none;
    }

    .form-control {
        color: #6A7992 !important;
        font-size: 16px !important;
        font-family: "proxima-nova" !important;
        padding: 6px 13px;
        background-color: white !important;
    }

        .form-control.empty {
            color: #9DA8B7 !important;
            background-color: white !important;
        }

    .floating-label {
        top: 15px;
        /*left: -2px;*/
        font-size: 10px !important;
        font-family: 'proxima-nova' !important;
        font-weight: 300 !important;
        text-transform: uppercase;
    }

    .icon-input-error {
        right: 25px;
    }

    .text-error {
        color: #ee653b;
        font-family: "proxima-nova";
        font-size: 12px;
        font-weight: bold;
    }

    .requred-input-indicator {
        right: 8px;
    }

    .focus-visible {
        background-color: white !important;
    }

    .my-custom-input .floating-label {
        left: -2px;
    }
</style>


// WEBPACK FOOTER //
// input-text.vue?73f76c97